import React from "react";
const Register: React.FC = () => <div>Register Form (student sign up)</div>;
export default Register;
